import { dateFormatter, formatDateRange } from '@sparklayer-io/spark-dash-core/utils/format-date';
import { LineChart } from '@ui/themed';
import { t } from 'i18next';
import {
  type SalesMetric,
  useSalesChartData,
} from '../features/purchases/hooks/use-sales-chart-data';
import type { SalesComparisonReport } from '../features/purchases/hooks/use-sales-performance';

export function SalesPerformanceChart({
  data,
  metric,
}: {
  data: SalesComparisonReport;
  metric: SalesMetric;
}) {
  const chartData = useSalesChartData(data, metric);

  return (
    <LineChart
      data={chartData.data}
      tooltipTitle={t('features:home.components.sales_performance_card.chart.tooltip_title')}
      valueFormatter={chartData.valueFormatter}
      xAxisFormatter={dateFormatter.format}
      primaryLabel={formatDateRange(data.current.start, data.current.end)}
      secondaryLabel={formatDateRange(data.previous.start, data.previous.end)}
    />
  );
}
